import React, { useEffect, useState } from 'react';
import CorporationUsageResource from './element/CorporationUsageResource';
import CorporationContractInfo from './element/CorporationContractInfo';
import CorporationOptionUsage from './element/CorporationOptionUsage';
import CorporationProvideFunction from './element/CorporationProvideFunction';
import CorporationInvidualBasicSetting from './element/CorporationInvidualBasicSetting';
import { Button } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import { getInitDataViewDetailContract, handleClosePopup, onSubmitChangeStandardRootOrg } from './EditOrganizationHandler';
import GroupActionBlockAndDeleteCorporation from './GroupActionBlockAndDeleteCorporation';
import "./rootOrganization.css"
import { bgContractStatus, displayContractStatus } from './ListOrganizationHandler';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import Utils from '@/common/utils/utils';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

export default function ViewDetailContractInfo({
    titleBars,
    setTitleBars,
    contractDetail,
    ...props
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [selectedProduct, setSelectedProduct] = useState({});
    const [selectedEdition, setSelectedEdition] = useState({});
    const [selectedVersion, setSelectedVersion] = useState({});
    const [listVersion, setListVersion] = useState([]);
    const [rootCorporationInfo, setRootOrganizationInfo] = useState({});
    const [resourceList, setResourceList] = useState([]);
    const [optionUsages, setOptionUsages] = useState([]);
    const [listProvideFunction, setListProvideFunction] = useState([]);
    const [listProvideFunctionDefaults, setListProvideFunctionDefaults] = useState([]);
    const [rootLicenseKeyValue, setRootLicenseKeyValue] = useState('');

    const [listInvidualBasic, setListInvidualBasic] = useState([]);
    const [contractInfo, setContractInfo] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [isErr, setIsErr] = useState(false);
    const [isShowDialogCancel, setIsShowDialogCancel] = useState(false);
    const [isShowDialogFailUpdated, setIsShowDialogFailUpdated] = useState({status: false, message: ''});
    const [corpActiveIsBlock, setCorpActiveIsBlock] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [lincenseKey, setLincenseKey] = useState({
        value: '',
        error: ''
    });
    const [isRootSetting, setIsRootSetting] = useState(true);
    const [isChangeLincenseKey, setIsChangeLincenseKey] = useState(false);
    const [isSettingLicenseKeyByCorp,setIsSettingLicenseKeyByCorp] = useState(false);

    useEffect(() => {
        let data = getInitDataViewDetailContract(contractDetail);
        setSelectedProduct(data?.productData);
        setSelectedEdition(data?.editionData);
        setSelectedVersion(data?.versionData);
        setListVersion(data?.listVersion);
        setRootOrganizationInfo(contractDetail?.corporationData);

        setResourceList(data?.listResources);
        setOptionUsages(data?.listOptionUsages);
        setListProvideFunction(data?.listProvideFunction);
        setListProvideFunctionDefaults(data?.listProvideFunction);
        setListInvidualBasic(data?.listInvidualBasicSettings);
        setContractInfo(contractDetail?.contractDetail);

        if(!Utils.isEmptyString(contractDetail?.corporationData?.limitValue?.lincenseKeyValue)) {
            setIsSettingLicenseKeyByCorp(true)
        }

        // Key setting by root corporation
        if (!Utils.isEmptyString(contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.key)) {
            setRootLicenseKeyValue(contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.key);
        } else {
            setRootLicenseKeyValue('');
        }

        let affiliationOrganizationSetting = contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.affiliationOrganization
            ? contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.affiliationOrganization
            : data?.productData?.moduleSetting?.lincenseKeySetting?.affiliationOrganization;

        if (userDetail.affiliationOrganization !== affiliationOrganizationSetting) {
            setIsRootSetting(false);
        }
        
        if (!Utils.isEmptyObject(contractDetail?.corporationData)) {
            let currentCorp = contractDetail?.corporationData;
            const isCheckCorpActiveIsBlock = currentCorp.active == Constant.CORPORATION_ACTIVE.BLOCK;
            setCorpActiveIsBlock(isCheckCorpActiveIsBlock);
        }

        // Init first license key
        let initLincenseKey = {
            value: '',
            error: ''
        }
        if (contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.key) {
            initLincenseKey.value = contractDetail?.corporationData?.limitValue?.lincenseKeySetting?.key;
        } else if (
            !contractDetail?.corporationData?.limitValue.hasOwnProperty('lincenseKeySetting') &&
            data?.productData?.moduleSetting?.lincenseKeySetting?.key
        ) {
            initLincenseKey.value = data?.productData?.moduleSetting?.lincenseKeySetting?.key;
        }
        setLincenseKey(initLincenseKey);

        // clean up
        return () => {
            setSelectedProduct({});
            setSelectedEdition({});
            setSelectedVersion({});
            setListVersion({});
            setRootOrganizationInfo({});
        };
    }, [contractDetail]);

    useEffect(() => {
        const error = listInvidualBasic.filter(item => !Utils.isEmptyString(item.error));
        const lincenseKeySwitch = listProvideFunction.find(
            i =>
                i.label ===
                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION
        );

        if (
            error.length > 0 ||
            (Utils.isEmptyString(lincenseKey?.value) &&
                lincenseKeySwitch?.switchCorporation &&
                !selectedProduct?.moduleSetting?.lincenseKeySetting?.key)
        ) {
            return setIsErr(true);
        }

        setIsErr(false);
    }, [
        listInvidualBasic,
        listProvideFunction,
        lincenseKey?.value,
        selectedProduct?.moduleSetting?.lincenseKeySetting?.key
    ]);

    const onClickExpand = index => {
        setTitleBars(prev => {
            let prevClone = [...prev];
            let currentStatus = prev[index].isExpand;
            prevClone[index].isExpand = !currentStatus;
            return prevClone;
        });
    };

    const handleDisabled = () => {
        if (isErr)  return true;
        
        return !isEdit;
    }

    const groupButtonSubmit = () => {
        return (
            <div className="head-btn">
                <div
                    className="head-btn-wrap"
                    style={{
                        minHeight: '32px',
                        float: 'right',
                        width: '100%',
                        justifyContent: 'flex-end'
                    }}
                >
                    <div className="btn-cancel">
                        <Button
                            className="btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={handleDisabled()}
                            onClick={() => setIsShowDialogCancel(isEdit)}
                        >
                            {I18n.get('COMBTN001')}
                        </Button>
                    </div>
                    <div className="btn-submit">
                        <Button
                            className="btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={handleDisabled()}
                            onClick={async () =>
                                await onSubmitChangeStandardRootOrg(
                                    rootCorporationInfo?.id,
                                    userDetail,
                                    listProvideFunction,
                                    listProvideFunctionDefaults,
                                    selectedVersion,
                                    listInvidualBasic,
                                    props.setIsLoading,
                                    props.setTriggerReload,
                                    setIsShowDialogCancel,
                                    enqueueSnackbar,
                                    setIsEdit,
                                    setIsShowDialogFailUpdated,
                                    lincenseKey,
                                    setLincenseKey,
                                    isChangeLincenseKey
                                )
                            }
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const renderSectionContentByTitleBar = componentId => {
        switch (componentId) {
            case Constant.ROOT_CORPORATION.TOOL_BAR.CONTRACT_INFO:
                return (
                    <CorporationContractInfo
                        selectedProduct={selectedProduct}
                        selectedEdition={selectedEdition}
                        selectedVersion={selectedVersion}
                        setSelectedVersion={setSelectedVersion}
                        listVersion={listVersion}
                        rootCorporationInfo={rootCorporationInfo}
                        contractInfo={contractInfo}
                        setIsEdit={setIsEdit}
                        corpActiveIsBlock={corpActiveIsBlock}
                    />
                );
            case Constant.ROOT_CORPORATION.TOOL_BAR.RESOURCE_USAGE:
                return (
                    <CorporationUsageResource
                        resourceList={resourceList}
                        rootCorporationInfo={rootCorporationInfo}
                        listProvideFunction={listProvideFunction}
                    />
                );
            case Constant.ROOT_CORPORATION.TOOL_BAR.OPTION_USAGE:
                return <CorporationOptionUsage optionUsages={optionUsages} />;
            case Constant.ROOT_CORPORATION.TOOL_BAR.PROVIDE_FUNCTION:
                return (
                    <CorporationProvideFunction
                        selectedProduct={selectedProduct}
                        selectedEdition={selectedEdition}
                        selectedVersion={selectedVersion}
                        listProvideFunction={listProvideFunction}
                        rootCorporationInfo={rootCorporationInfo}
                        setListProvideFunction={setListProvideFunction}
                        setListInvidualBasic={setListInvidualBasic}
                        setIsEdit={setIsEdit}
                        corpActiveIsBlock={corpActiveIsBlock}
                        lincenseKey={lincenseKey}
                        setLincenseKey={setLincenseKey}
                        isRootSetting={isRootSetting}
                        setIsChangeLincenseKey={setIsChangeLincenseKey}
                        isSettingLicenseKeyByCorp={isSettingLicenseKeyByCorp}
                        rootLicenseKeyValue={rootLicenseKeyValue}
                    />
                );
            case Constant.ROOT_CORPORATION.TOOL_BAR.INVIDUAL_BASIC_SETTING:
                return <CorporationInvidualBasicSetting 
                    listInvidualBasic={listInvidualBasic} 
                    setListInvidualBasic={setListInvidualBasic} 
                    setIsEdit={setIsEdit}
                    corpActiveIsBlock={corpActiveIsBlock}
                    listProvideFunction={listProvideFunction}
                    />;
            default:
                return null;
        }
    };

    const isShowTabOptionUsage = () => {
        return selectedVersion?.moduleSetting?.advancedOptionSettings;
    }

    return (
        <>
            {groupButtonSubmit()}

            <GroupActionBlockAndDeleteCorporation
                {...props}
                organizationDetail={rootCorporationInfo}
                setTriggerReload={props.setTriggerReload}
            />
            <div className='head-btn head-contract-status'>
                <span className='contract-status'>{I18n.get('LABEL-NOTI-CONTRACT-STATUS')}</span>
                <span className={`warning-contract warning-contract-${bgContractStatus(rootCorporationInfo.contractStatus)}`}>{displayContractStatus(rootCorporationInfo.contractStatus)}</span>
            </div>
            {titleBars &&
                titleBars.map((titlebar, index) => {
                    if(!isShowTabOptionUsage() && titlebar.id === Constant.ROOT_CORPORATION.TOOL_BAR.OPTION_USAGE) {
                        return null;
                    }
                    return (
                        <div
                            key={titlebar.id}
                            className={`${
                                titlebar.isExpand
                                    ? 'groups-tab-contract-detail groups-tab-contract-detail-show'
                                    : 'groups-tab-contract-detail'
                            }`}
                        >
                            <div className="title-bar-contract">
                                <label className="title-head" onClick={() => onClickExpand(index)}>
                                    {titlebar.label}
                                </label>
                                <div className="section-contract-content">
                                    {renderSectionContentByTitleBar(titlebar.id)}
                                </div>
                            </div>
                        </div>
                    );
                })}

            {/* dialog cancel  */}
            <ConfirmDialog
                isOpen={isShowDialogCancel}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onSubmitChangeStandardRootOrg(
                        rootCorporationInfo?.id,
                        userDetail,
                        listProvideFunction,
                        listProvideFunctionDefaults,
                        selectedVersion,
                        listInvidualBasic,
                        props.setIsLoading,
                        props.setTriggerReload,
                        setIsShowDialogCancel,
                        enqueueSnackbar,
                        setIsEdit
                    )
                }
                closeCallBack={() =>
                    closePanelTab({
                        event: null,
                        panelType: props.panelType,
                        panelId: props.panelId,
                        tabId: props.tabId
                    })
                }
                cancelCallBack={() => {
                    setIsShowDialogCancel(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />
            <ConfirmDialog
                isOpen={isShowDialogFailUpdated.status}
                msgConfirm={I18n.get(isShowDialogFailUpdated.message)}
                okCallBack={() => handleClosePopup(isShowDialogFailUpdated.message, setIsShowDialogFailUpdated, selectedVersion, setSelectedVersion, listVersion, setListVersion)}
            />
        </>
    );
}

ViewDetailContractInfo.propTypes = {
    contractDetail: PropTypes.object,
}